// extracted by mini-css-extract-plugin
export var boldText = "_6m-4";
export var checkboxContainer = "_6m-6";
export var closeIcon = "_6m-i";
export var container = "_6m-0";
export var drawer = "_6m-8";
export var drawerContent = "_6m-9";
export var extraSmallText = "_6m-5";
export var fulfillmentGroupTable = "_6m-e";
export var largeText = "_6m-3";
export var loadingSpinnerContainer = "_6m-j";
export var mediumText = "_6m-2";
export var narrow = "_6m-f";
export var notificationLink = "_6m-l";
export var packageCheckIconContainer = "_6m-7";
export var slideoutHeaderActions = "_6m-g";
export var slideoutHeaderActionsShifted = "_6m-h";
export var slideoutHeaderContainer = "_6m-a";
export var slideoutModal = "_6m-c";
export var stickyHeaderWrapper = "_6m-b";
export var table = "_6m-k";
export var tableContainer = "_6m-d";
export var tertiaryText = "_6m-1";